var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"heartbeatLoading",class:{hidden: !_vm.active}},[_c('div',{staticClass:"pulse",style:(_vm.styles)}),_c('div',{staticClass:"pulse",style:(_vm.styles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }